import React from "react";
import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";
import Projects from "./projects";
import ProjectDetail from "./project-detail";
import ProjectDrawing from "./project-drawing";
import { DesignContextProvider } from "../../../context/design";

const DesignProjectDrawing = () => {
  return (
    <DesignContextProvider>
      <ProjectDrawing />
    </DesignContextProvider>
  );
};

export default () => {
  const match = useRouteMatch();
  return (
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/projects`} />
      <Route path={`${match.url}/projects`} component={Projects} />
      <Route path={`${match.url}/project-detail`} component={ProjectDetail} />
      <Route
        path={`${match.url}/project-drawing`}
        component={DesignProjectDrawing}
      />
      <Redirect to="/404" />
    </Switch>
  );
};
